import assignGlobal from 'js/utils/assign_global';

import { MentionsSettingsContainer } from 'js/settings/components/mentions_settings/mentions_settings_container';
import renderOnsitePing from 'js/onsite_pings/onsite_pings.wjs';
import 'js/i18n/translations/affiliation_editor';
import { ProfileFeed } from 'js/social/ProfileFeed';
import registerForRails from 'js/utils/registerForRails';
import { trackClick } from 'js/utils/trackClick';
import { currentUser } from 'js/utils/user';
import { watchImpressions } from 'js/utils/impressions/watchImpressions';
import { ProfileCheckPaperUpdate } from 'js/social/ProfileCheckPaperUpdate';
import { Pill } from 'js/social/shared/design_system/Pill';
import SuggestedAcademics from 'js/social/SuggestedAcademics';
import { setUpLeftSidebarButtons } from 'js/profiles/setUpLeftSidebarButtons';
import { getMentionsCount } from 'js/profiles/api/mentions_api';
import formatNumber from 'js/utils/format';
import { setUpFigureCarousel } from 'js/single_work/loswp/setUpFigureCarousel';
import { ProfileList } from 'js/podcast_ai/ProfileList';
import { SimplePaperPodcast } from 'js/podcast_ai/SimplePaperPodcast';
import { PodcastLibraryProfileBanner } from 'js/podcast_library/PodcastLibraryProfileBanner';
import RelatedAuthorProfileImage from 'js/social/profile/RelatedAuthorProfileImage';
import ImpactHubModal from 'js/modals/ImpactHubModal';

assignGlobal('Aedu', { renderOnsitePing: renderOnsitePing });
assignGlobal('Aedu', { MentionsSettingsContainer: MentionsSettingsContainer });

registerForRails({
  ProfileFeed,
  ProfileList,
  ProfileCheckPaperUpdate,
  Pill,
  SuggestedAcademics,
  SimplePaperPodcast,
  PodcastLibraryProfileBanner,
  RelatedAuthorProfileImage,
  ImpactHubModal,
});

// click tracking on profile page
// wrapped in if statement for profile_page_related_authors AB test
// clicks are not tracked when vieweing own profile page because this
// test implements no changes on when a user is logged in and
// viewing their own profile page, making self prof pg clicks
// irrelevant
if (currentUser == null || currentUser.id !== window.$viewedUser.id) {
  // Claims in profile-specific tracking
  document.querySelectorAll('.js-profile-claim').forEach((el) => {
    el.addEventListener('click', () => {
      const workStrip = el.closest('.js-work-strip');
      const workId = workStrip?.getAttribute('data-work-id');

      trackClick({
        source: 'profile-claim',
        entityId: workId ? parseInt(workId, 10) : null,
        extra: {
          visited_user_id: window.$viewedUser.id,
        },
      });
    });
  });

  document.querySelectorAll('[data-click-track]').forEach((el) => {
    // Skip claim links as they're handled above. Need to remove after claims in profile test
    if (el.classList.contains('js-profile-claim')) return;

    el.addEventListener('click', () => {
      trackClick({ source: el.getAttribute('data-click-track') });
    });
  });
}

document.querySelectorAll('[data-impressions').forEach((el) => {
  const source = 'soc_prof_info_sugg';
  watchImpressions(el, { source: source });
});

// This used to be done in the controller, but the CombinedMention query
// takes far too long.
const loadMentionsCount = async () => {
  const mentionsCount = await getMentionsCount(window.$viewedUser.id);
  const containerEl = document.querySelector('.js-mentions-count-container');
  if (!containerEl) return;

  if (mentionsCount > 10 || (currentUser && mentionsCount > 0)) {
    const url = new URL(window.location.href);
    const pathname = url.pathname.endsWith('/')
      ? url.pathname.slice(0, -1)
      : url.pathname;
    const mentionsUrl = `${pathname}/mentions${url.search}`;

    containerEl.innerHTML = `
      <a href="${mentionsUrl}">
        <div class="stat-container">
          <p class="label">Mentions</p>
          <p class="data">${formatNumber(mentionsCount)}</p>
        </div>
      </a>
    `;

    const linkEl = containerEl.querySelector('a');
    linkEl.addEventListener('click', () => {
      trackClick({ source: 'profile-user-info-mentions' });
    });
  }
};

// Call immediately if loaded, otherwise call on DOMContentLoaded
if (document.readyState === 'complete') {
  loadMentionsCount();
} else {
  document.addEventListener('DOMContentLoaded', loadMentionsCount);
}

setUpFigureCarousel();
setUpLeftSidebarButtons();
